import React from 'react';
import { FormattedTime } from 'react-intl';

import { TIME_FORMAT } from 'utils/dateFormats';

type StandardTimeProps = Pick<React.ComponentProps<typeof FormattedTime>, 'value'>;

const StandardTime: React.FC<StandardTimeProps> = ({ value }) => (
  // eslint-disable-next-line no-restricted-syntax
  <FormattedTime value={value} {...TIME_FORMAT} />
);

export default StandardTime;